import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSurveyInviteQuery, useUpdateStudentSurveyFormMutation } from 'graphql/hooks.generated'
import { Survey } from 'survey-react-ui'
import { Model, ComputedUpdater } from 'survey-core'
import { engLoc, spaLoc } from 'config/constants/translations'
import 'survey-core/modern.min.css'
import 'survey-core/defaultV2.css'
import ProgressIndicator from 'components/ui/panel/progress-indicator/ProgressIndicator'
import './survey.css'
import { Step, StepLabel, Stepper, makeStyles } from '@material-ui/core'

interface ActivateAccountParams {
  token: string
  language_id: string
}

export const SurveyForm = () => {
  const params = useParams<ActivateAccountParams>()
  const [thankYouScreen, setThankYouScreen] = useState(false)
  const [youththankYouScreen, setyouthThankYouScreen] = useState<any>()
  const [spanishthankYouScreen, setspanishThankYouScreen] = useState<any>()
  const { data: surveyData, loading, error } = useSurveyInviteQuery({
    variables: { token: params.token }
  })
  const [surveyDatas, setSurveyData] = useState(null)
  useEffect(() => {
    const surveyInvite = surveyData?.surveyInvite

    if (surveyInvite?.[0]?.result_json) setSurveyData(JSON.parse(surveyInvite[0].result_json))
  }, [surveyData])
  const language = params.language_id
  const langcode = surveyData?.surveyInvite?.[0]?.language_id === 1 ? 'en' : 'es'
  const survey = new Model(surveyData?.surveyInvite?.[0]?.form_json)
  const [updateStudentSurvey] = useUpdateStudentSurveyFormMutation()
  const [pageNo, setPageNo] = React.useState(0)
  const isLoading = () => (loading ? <ProgressIndicator fullHeight /> : '')
  const saveFinalise = async () => {
    survey.ignoreValidation = false

    if (survey.completeLastPage())
      updateStudentSurvey({
        variables: {
          token: params.token,
          input: {
            id: String(surveyData?.surveyInvite?.[0]?.form_id),
            result_json: JSON.stringify(survey.data),
            iscompleted: true
          }
        }
      })
  }

  function filterCommonWithValues(array, object) {
    // Filter common keys between the array and the object
    const commonKeys = array.filter((item) => Object.keys(object).includes(item))
    // Map each common key to its corresponding value in the object
    const commonObject = {}
    commonKeys.forEach((key) => {
      commonObject[key] = object[key]
    })

    return commonObject
  }

  const youth = [
    'pageNo',
    'Please start by telling us who you are:',
    'How did you hear about I Matter?1',
    'Where did you hear about I Matter?1',
    'AgeGroup1',
    'youthwellbeing1',
    'Where did you hear about I Matter?1 comment1',
    'starting I Matter1',
    'How is it going with your provider?1',
    'How did you hear about I Matter comment1',
    'Recommend I matter1',
    'Additional feedback1',
    'Recommend I matter1 comment'
  ]
  const parent = [
    'Please start by telling us who you are:',
    'How did you hear about I Matter?2',
    'How did you hear about I Matter comment2',
    'Where did you hear about I Matter?2 comment2',
    'Where did you hear about I Matter?2',
    'AgeGroup2',
    'youthwellbeing2',
    'starting I Matter2',
    'Recommend I matter2 comment',
    'Recommend I matter2',
    'Additional feedback2'
  ]
  const saveSurveyData = (survey: any) => {
    const data = { ...survey.data }
    let commonObject: any = {}

    if (data['Please start by telling us who you are:'] === '1')
      commonObject = filterCommonWithValues(youth, data)
    if (data['Please start by telling us who you are:'] === '2')
      commonObject = filterCommonWithValues(parent, data)

    commonObject.pageNo = survey.currentPageNo
    survey.textUpdateMode = 'onTyping'
    updateStudentSurvey({
      variables: {
        token: params.token,
        input: {
          id: String(surveyData?.surveyInvite?.[0]?.form_id),
          result_json: JSON.stringify(commonObject),
          iscompleted: false
        }
      }
    })
    setSurveyData(commonObject)
  }
  survey.data = surveyDatas
  const prevPage = () => {
    survey.prevPage()
    saveSurveyData(survey)
    setPageNo(survey.currentPageNo)
    window.scrollTo(0, 0)

    // autoSaveSurveyDataButtonClick() // #TODO need to finalize one fix for auto-save fetaure
  }

  if (survey.pageCount > 1)
    survey.addNavigationItem({
      id: 'survey_prev_page',
      title: `${
        surveyData?.surveyInvite?.[0]?.form_template_id === 'd913c500-13f1-433d-929f-a3663fe24ad4'
          ? 'Back'
          : 'Regresar'
      }`,
      visibleIndex: 49,
      visible: new ComputedUpdater(() => {
        return !survey.isFirstPage
      }),
      css: 'nav-button',
      innerCss: `sd-btn nav-input-${pageNo}`,
      action: () => {
        prevPage()
      }
    })

  const nextPage = () => {
    if (survey.isCurrentPageValid) {
      survey.nextPage()
      saveSurveyData(survey)
      setPageNo(survey.currentPageNo)
      window.scrollTo(0, 0)
    }
  }

  if (survey.pageCount > 0)
    survey.addNavigationItem({
      id: 'survey_next_page',
      // title: 'Next',
      title: `${
        surveyData?.surveyInvite?.[0]?.form_template_id === 'd913c500-13f1-433d-929f-a3663fe24ad4'
          ? 'Next'
          : 'Próximo'
      }`,
      visibleIndex: 49,
      visible: new ComputedUpdater(() => {
        return !survey.isLastPage
      }),
      css: 'nav-button',
      innerCss: `sd-btn nav-input-${pageNo}`,
      action: () => {
        nextPage()
      }
    })

  survey.render('surveyContainer')
  survey.addNavigationItem({
    id: 'sv-nav-complete',
    css: 'nav-button',
    innerCss: `sd-btn nav-input-${pageNo}`,
    title: `${
      surveyData?.surveyInvite?.[0]?.form_template_id === 'd913c500-13f1-433d-929f-a3663fe24ad4'
        ? 'Submit'
        : 'entregar'
    }`,
    visibleIndex: 49,
    visible: new ComputedUpdater(() => {
      return survey.isLastPage
    }),
    action: () => {
      saveFinalise()
      setyouthThankYouScreen(survey.data['Please start by telling us who you are:'])
      setspanishThankYouScreen(survey.data['Please start by telling us who you are:'])
      setThankYouScreen(true)
    }
  })

  if (error)
    return (
      <div className="jss1 jss2" style={{ backgroundColor: 'red', textAlign: 'center' }}>
        <div
          style={{
            marginTop: '17%',
            backgroundColor: 'white',
            margin: '15%',
            justifyContent: 'center',
            // width: '50%',
            color: 'black',
            padding: '2%',
            fontFamily: 'poppins'
          }}
        >
          {error.message === 'English Invalid Token'
            ? 'Link Expired.'
            : error.message === 'Spanish Invalid Token'
            ? 'Enlace expirado.'
            : error.message === 'jwt expired' && language === '1'
            ? 'Sorry, this survey has closed. Thank you.'
            : 'Lo sentimos, esta encuesta está cerrada. Muchas gracias.'}
        </div>
      </div>
    )

  const devstylename =
    survey.data['Please select the option that best describes you:'] === '2' &&
    survey.data['Please start by telling us who you are:'] === '1' &&
    pageNo === 5
      ? `innerstyle-${pageNo}-12yrs`
      : survey.data['Please start by telling us who you are:'] === '3' && pageNo === 5
      ? `innerstyle-${pageNo}-c`
      : survey.data['Selecciona la opción que mejor te describa:'] === '2' &&
        survey.data['Para empezar, díganos quién es usted:'] === '1' &&
        pageNo === 5
      ? `innerstyle-${pageNo}-12yrs`
      : survey.data['Para empezar, díganos quién es usted:'] === '3' && pageNo === 5
      ? `innerstyle-${pageNo}-c`
      : `innerstyle-${pageNo}`
  survey.applyTheme({
    cssVariables: {
      backgroundColor:
        pageNo === 0
          ? '#844191'
          : pageNo === 1
          ? '#00de74'
          : pageNo === 2
          ? '#ff51a7'
          : pageNo === 3
          ? '#ff6400'
          : pageNo === 4
          ? '#3e49b5'
          : pageNo === 5
          ? '#ffc22d'
          : pageNo === 6
          ? '#ff1c00'
          : pageNo === 7
          ? '#201057'
          : 'red'
    },
    themeName: 'ContrastLight',
    colorPalette: 'dark',
    isPanelless: false
  })
  const steps = ['', '', '', '', '', '', '']
  const colors = {
    0: '#844191',
    1: '#00de74',
    2: '#ff51a7',
    3: '#ff6400',
    4: '#3e49b5',
    5: '#ffc22d',
    6: '#ff1c00',
    7: '#201057'
  }
  const css = `.MuiFormControlLabel-label {
    font-family: 'Poppins'
    }
    .MuiFormLabel-root.Mui-focused {
    color: #293f70
    }
    .nextBtn {
      color: #fff;
      background-color: ${colors[pageNo]};
      box-shadow: none;
    }
    .nextBtn:hover {
      background-color: ${colors[pageNo]};
    }
    .backBtn {
      border: 1px solid ${colors[pageNo]}
    }
    .backBtn:hover {
      background-color: transparent;
    }
    .MuiRadio-colorPrimary.Mui-checked {
      color: ${colors[pageNo]}
    }
    .MuiStepIcon-root.MuiStepIcon-active {
      color: ${colors[pageNo]}
    }
    .MuiStepIcon-root.MuiStepIcon-completed {
      color: ${colors[pageNo]}
    }
    .MuiCheckbox-colorSecondary.Mui-checked {
      color: ${colors[pageNo]}
    }`

  return (
    <>
      {isLoading()}
      {/* {!loading && !thankYouScreen ? 
      <Survey currentPageNo={pageNo} model={survey} /> : ''} */}
      {!loading && !thankYouScreen && (
        <>
          <div>
            <style>{css}</style>
            <Stepper activeStep={pageNo} alternativeLabel>
              {steps.map((pageNo) => (
                <Step key={pageNo}>
                  <StepLabel>{pageNo}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>
          <div className={devstylename}>
            <Survey currentPageNo={pageNo} model={survey} isLoading={survey.isLoadingFromJson} />
          </div>
        </>
      )}
      {thankYouScreen && (
        <div className="jss1 jss2" style={{ backgroundColor: '#00de74', textAlign: 'center' }}>
          <div
            className="spinner"
            style={{
              backgroundColor: 'white',
              margin: '15%',
              justifyContent: 'center',
              // width: '50%',
              color: 'black',
              padding: '2%',
              fontFamily: 'poppins'
            }}
          >
            {youththankYouScreen === '1' && langcode === 'en'
              ? engLoc.youthThankYouMessage.text1
              : youththankYouScreen === '2' && langcode === 'en'
              ? engLoc.parentThankYouMessage.text1
              : youththankYouScreen === '3' && langcode === 'en'
              ? engLoc.counsellorMessage.text1
              : spanishthankYouScreen === '1' && langcode === 'es'
              ? spaLoc.youthThankYouMessage.text1
              : spanishthankYouScreen === '2' && langcode === 'es'
              ? spaLoc.parentThankYouMessage.text1
              : spaLoc.counsellorMessage.text1}
          </div>
        </div>
      )}{' '}
    </>
  )
}
